import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ContractService } from "../../../../../auth/service/contract.service";
import { JobSiteService } from "../../../../../auth/service/job-sites.service";
import { CitiesService } from "../../../../../auth/service/cities.service";
import { AuthenticationService, UserService } from "../../../../../auth/service";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { UserFigureService } from "../../../../../auth/service/user-figure.service";
import { BargainingService } from "../../bargaining.service";
import { UtilsService } from "../../../../../auth/service/utils.service";
import * as moment from "moment";
import { locale as italian } from "../../../../../i18n/it";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ManageBargainingContractService } from "../../../../../auth/service/manage-bargaining-contract.service";
import { CandidateService } from "../../../candidates/candidate.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-edit-bargaining",
  templateUrl: "./edit-bargaining.component.html",
  styleUrls: ["./edit-bargaining.component.scss"],
})
export class EditBargainingComponent implements OnInit {
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();
  @ViewChild("noteModal") noteModal: ElementRef;
  @ViewChild("noteDisableBargaining") noteDisableBargaining: ElementRef;
  public contentHeader: IContentHeader;
  public formGroup: FormGroup;
  public contracts: any = [];
  public currentBargaining: any;
  public bargainingCandidate: any = {};
  public idBargaining: number;
  public today_date: string;
  public status_note: string = "";
  public disableNote: string = "";
  public reject_type: string = "";
  public activeTab: string;
  public candidateBecameEmployee: boolean = false;

  constructor(
    public _contractService: ContractService,
    public _contractManager: ManageBargainingContractService,
    public _jobSiteService: JobSiteService,
    private _changeDetectorRef: ChangeDetectorRef,
    public _citiesService: CitiesService,
    public _authenticationService: AuthenticationService,
    private _activatedRoute: ActivatedRoute,
    private _userService: UserService,
    public _userFigureService: UserFigureService,
    public _bargainingService: BargainingService,
    public _utilService: UtilsService,
    private _router: Router,
    public _modalService: NgbModal,
    public _candidateService: CandidateService,
  ) {
    this._utilService.disableAutoHideLoading();
    this._activatedRoute.paramMap.subscribe(async (params: ParamMap) => {
      this.idBargaining = Number(params.get("id"));
    });
    this.today_date = moment().format("YYYY-MM-DD");
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("edit_bargaining")) {
      this._utilService.hideLoading();
      this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.contracts = await this._contractService.getList();
    await this.loadBargaining();
  }

  ngOnDestroy() {
    this._contractManager.resetData();
  }

  async loadBargaining() {
    this.currentBargaining = await this._bargainingService
      .getBargaining(this.idBargaining)
      .then((result: any) => {
        if (result.status !== 2) {
        }
        return result;
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showToastrError("ERROR_NOT_FOUND_BARGAINING");
        await this._router.navigateByUrl("/dashboard/main");
        return false;
      });

    if (!this.currentBargaining) {
      this._utilService.hideLoading();
      await this._utilService.showToastrError("ERROR_NOT_FOUND_BARGAINING");
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.currentBargaining) {
      this.contentHeader = {
        headerTitle: italian.data.MENU.EDIT_BARGAINING + " " + italian.data.FOR + " " + this.currentBargaining.user.firstname + " " + this.currentBargaining.user.lastname,
        actionButton: false,
        breadcrumb: {
          type: "",
          links: [
            {
              name: "Home",
              isLink: true,
              link: "/",
            },
            {
              name: "MENU.BARGAINING_LIST",
              isLink: true,
              link: "/dashboard/bargaining-list",
            },
            {
              name: italian.data.MENU.EDIT_BARGAINING + " " + italian.data.FOR + " " + this.currentBargaining.user.firstname + " " + this.currentBargaining.user.lastname,
              isLink: false,
            },
          ],
        },
      };
    }

    if (this.currentBargaining.status === 1) {
      const desired: any = await this._userService.getDesiredContract(this.currentBargaining.user.hash);
      this.bargainingCandidate = await this._candidateService.getCandidate(this.currentBargaining.user.hash).then((result: any) => {
        return { ...result, ...desired };
      });
    } else {
      this.bargainingCandidate = await this._candidateService.getCandidate(this.currentBargaining.user.hash);
    }
    if (Object.keys(this.currentBargaining).length > 0) {
      await this._contractManager.init(this.currentBargaining);
      this._contractManager.data.role = this.currentBargaining.role_id;
    } else {
      await this._contractManager.init();
    }

    this._contractManager.data.record_type = "desiderata";
    if (this.currentBargaining && this.currentBargaining.user.birthday) {
      this.currentBargaining.apprenticeship = moment().diff(this.currentBargaining.user.birthday, "years");
    }

    const statusDocument: number = this.currentBargaining.bargaining_document.status;
    const statusContract: number = this.currentBargaining.bargaining_contract.status;

    this.currentBargaining.timeline_status = statusContract + statusDocument;

    if (statusDocument === 3 && statusContract >= 0) {
      this.currentBargaining.timeline_status -= 1;
    }

    if (this.currentBargaining.status === 2) {
      this.currentBargaining.timeline_status = 6;
    }

    if (statusDocument === 4) {
      this.currentBargaining.timeline_status = 1;
    }

    if (statusContract === 4) {
      this.currentBargaining.timeline_status = 3;
    }

    //Controllo che la contrattazione sia completata e che il candidato sia diventato effettivamente dipendente
    if (this.currentBargaining.timeline_status === 5 && moment() >= moment(this.currentBargaining.start_date)) {
      this.candidateBecameEmployee = true;
    }

    this._utilService.hideLoading();
    this._changeDetectorRef.detectChanges();
  }

  fieldHasErrors(field_name: string): boolean {
    return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
  }

  isDisabledSave() {
    if (this._contractManager.typeIsStage) {
      //Controllo in caso di contratto a stage
      if (
        this._contractManager.data.role === "" ||
        this._contractManager.data.contract < 1 ||
        Number(this._contractManager.data.net_monthly_12) < 1 ||
        this._contractManager.data.start_date === "" ||
        !this._contractManager.data.tutor_hash ||
        !this._contractManager.data.end_date
      ) {
        return true;
      }
      return false;
    }
    if (
      this._contractManager.data.level === "" ||
      this._contractManager.data.role === null ||
      this._contractManager.data.contract === null ||
      (this._contractManager.data.gross_monthly_12 && this._utilService.removeDotsFromNumber(this._contractManager.data.gross_monthly_12) < 1) ||
      this._contractManager.data.trial === "" ||
      (this._contractManager.data.net_monthly_12 && this._utilService.removeDotsFromNumber(this._contractManager.data.net_monthly_12) < 1) ||
      (this._contractManager.data.net_monthly_13 && this._utilService.removeDotsFromNumber(this._contractManager.data.net_monthly_13) < 1) ||
      (this._contractManager.data.total_net_monthly_13 && this._utilService.removeDotsFromNumber(this._contractManager.data.total_net_monthly_13) < 1) ||
      (this._contractManager.data.salary_yearly_gross && this._utilService.removeDotsFromNumber(this._contractManager.data.salary_yearly_gross) < 1) ||
      (this._contractManager.data.total_daily && this._utilService.removeDotsFromNumber(this._contractManager.data.total_daily) < 1) ||
      this._contractManager.data.start_date === null
    ) {
      return true;
    }
    if (this._contractManager.data.contract === 3 && !this._contractManager.data.tutor_hash) {
      return true;
    }
    if (this._contractManager.data.contract !== 1 && !this._contractManager.data.end_date) {
      return true;
    }
    return false;
  }

  openModal(modal, type: string, modalSize: string) {
    this._modalService.open(modal, {
      centered: true,
      size: modalSize,
      backdrop: false,
      keyboard: false,
    });
    this.reject_type = type;
  }

  modalClose(isActionBack: boolean = false) {
    //Nel caso nella modale l'utente ha cliccato indietro riporto lo step a quello precedente
    if (isActionBack) {
      if (this.reject_type === "document") {
        this.currentBargaining.timeline_status = 1;
      }
      if (this.reject_type === "contract") {
        this.currentBargaining.timeline_status = 4;
      }
      if (this.reject_type === "disable") {
        const statusDocument: number = this.currentBargaining.bargaining_document.status;
        const statusContract: number = this.currentBargaining.bargaining_contract.status;
        this.currentBargaining.timeline_status = statusContract + statusDocument;
      }
    }

    this._modalService.dismissAll();
    this.status_note = "";
    this.reject_type = "";
    this.callbackFn.emit();
  }

  async requestDocumentMasterData() {
    if (!this._authenticationService.hasCapability("edit_bargaining")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    await this._candidateService
      .requestMasterData(this.currentBargaining.user.hash)
      .then(async () => {
        this._utilService.hideLoading();
        this.currentBargaining.status_document = 1;
        await this._utilService.showToastrSuccess("MASTERDATA_SENDED");
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showToastrError("MASTERDATA_SENDED_ERROR");
      });
  }

  async requestDocumentContract() {
    if (!this._authenticationService.hasCapability("edit_bargaining")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    await this.previewContract(false).then(async () => {
      await this._candidateService
        .requestSignContract(this.currentBargaining.user.hash)
        .then(async () => {
          this._utilService.hideLoading();
          this.currentBargaining.status_contract = 1;
          await this._utilService.showToastrSuccess("SUCCESS_REQUEST_CONTRACT_DOCUMENT");
        })
        .catch(async () => {
          this._utilService.hideLoading();
          await this._utilService.showToastrError("ERROR_REQUEST_CONTRACT_DOCUMENT");
        });
    });
  }

  async approveDocument(type: string) {
    if (!this._authenticationService.hasCapability("edit_bargaining")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    const data = {
      status: 3,
      type: type,
    };
    this._utilService.showLoading();
    await this._bargainingService
      .updateDocumentStatus(Number(this.idBargaining), data)
      .then(async () => {
        if (type === "contract") {
          this._utilService.hideLoading();
          this.currentBargaining.status = 1;
          this.currentBargaining.status_contract = 3;
          await this._utilService.showToastrSuccess("SUCCESS_APPROVED_DOCUMENT");
        }
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showToastrError("ERROR_APPROVED_DOCUMENT");
      });
  }

  async rejectDocument() {
    if (!this._authenticationService.hasCapability("edit_bargaining")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    let data = {
      status: 4,
      type: this.reject_type,
      status_note: this.status_note,
    };
    this.modalClose();
    this._utilService.showLoading();
    await this._bargainingService
      .updateDocumentStatus(Number(this.idBargaining), data)
      .then(async () => {
        this._utilService.hideLoading();
        data.type === "document" ? (this.currentBargaining.status_document = 4) : (this.currentBargaining.status_contract = 4);
        data.type === "document" ? (this.currentBargaining.bargaining_document.status_note = data.status_note) : (this.currentBargaining.bargaining_contract.status_note = data.status_note);
        await this._utilService.showToastrSuccess("SUCCESS_REJECT_DOCUMENT");
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showToastrError("ERROR_REJECT_DOCUMENT");
      });
  }

  async edit() {
    if (!this._authenticationService.hasCapability("edit_bargaining")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    let data = {
      bonus: String(this._contractManager.data.bonus),
      production_bonus: String(this._contractManager.data.production_bonus),
      contract: this._contractManager.data.contract,
      end_date: this._contractManager.data.end_date,
      gross_monthly_12: this._contractManager.data.gross_monthly_12,
      level: this._contractManager.data.level,
      role: this._contractManager.data.role,
      net_monthly_12: this._contractManager.data.net_monthly_12,
      net_monthly_13: this._contractManager.data.net_monthly_13,
      program: this._contractManager.data.program,
      salary_yearly_gross: this._contractManager.data.salary_yearly_gross,
      start_date: this._contractManager.data.start_date,
      ticket_month_number: this._contractManager.data.ticket_month_number,
      ticket_type: this._contractManager.data.ticket_type,
      ticket_value: String(this._contractManager.data.ticket_value),
      total_daily: this._contractManager.data.total_daily,
      total_net_monthly_13: this._contractManager.data.total_net_monthly_13,
      trial: this._contractManager.data.trial,
      tutor_hash: this._contractManager.data.tutor_hash,
    };
    if (this._contractManager.data.contract === 4) {
      //Controllo in caso di contratto a stage elimino campi superflui
      data.bonus = null;
      data.production_bonus = null;
      data.gross_monthly_12 = null;
      data.level = null;
      data.net_monthly_13 = null;
      data.salary_yearly_gross = null;
      data.ticket_month_number = null;
      data.ticket_type = null;
      data.ticket_value = null;
      data.total_net_monthly_13 = null;
      data.trial = null;
    }

    if (!data.end_date || data.end_date.length < 1) {
      data.end_date = null;
    }

    if (data.contract !== 1) {
      // if (data.end_date <= moment(data.start_date).add(data.trial, "days").format("YYYY-MM-DD")) {
      //   await this._utilService.showToastrError("CONTROL_CONTRACT_DATE");
      //   return false;
      // }
    }
    this._utilService.showLoading();
    await this._bargainingService
      .updateBargaining(Number(this.idBargaining), data)
      .then(async () => {
        if (this.currentBargaining.status_contract != 0) {
          await this._bargainingService.updateDocumentStatus(Number(this.idBargaining), { status: 0, type: "contract" }).then(async () => {
            this._utilService.hideLoading();
            await this._utilService.showToastrSuccess("SUCCESS_UPDATE_BARGAINING");
            this.currentBargaining.status_contract = 0;
            this.currentBargaining.timeline_status = 2;
          });
        } else {
          this._utilService.hideLoading();
          await this._utilService.showToastrSuccess("SUCCESS_UPDATE_BARGAINING");
        }
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showToastrError("ERROR_UPDATE_BARGAINING");
      });
  }

  async closeBargaining(idBargaining) {
    if (!this._authenticationService.hasCapability("edit_bargaining")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    // popup
    await this._utilService
      .showSWAL({
        title: "CONFIRM_CLOSE_BARGAINING",
        icon: "warning",
        confirmButtonText: "CONFIRM_BTN",
        customClass: {
          confirmButton: "btn btn-warning",
        },
      })
      .then(async (result) => {
        if (result.value) {
          await this._bargainingService
            .updateBargainingStatus(idBargaining, 1)
            // controllare i testi
            .then(async () => {
              await this.loadBargaining();
              await this._utilService.showToastrSuccess("SUCCESS_CLOSE_BARGAINING");
            })
            .catch(() => this._utilService.showToastrError("ERROR_CLOSE_BARGAINING"));
        }
      });
  }

  async previewContract(viewFile: boolean = true) {
    this._utilService.showLoading();
    await this._utilService.basic_get(`/candidate/${this.currentBargaining.user.hash}/contract?force=1`).then(async (response: any) => {
      if (response.contract && viewFile) {
        await this._utilService.getFile(response.contract);
        this._utilService.hideLoading();
      }
    });
  }

  transformRal(value: any) {
    value = this._utilService.fixRal(value);
    this._contractManager.changeSalaryGrossYearly(value);
  }

  changeTab(tab: string) {
    this.activeTab = this.activeTab === tab ? "" : tab;
    this._changeDetectorRef.detectChanges();
  }

  async drop(event) {
    const nextStep: number = Number(event.container.element.nativeElement.id.replace("step", ""));
    const currentStep: number = Number(this.currentBargaining.timeline_status);
    const availableSteps = [
      [1, 6], // contrattazione --> if(currentStep === 0 && nextStep !== 1 && nextStep !== 6) return false
      [6], // richiedi dati anagrafici --> if(currentStep === 1 && nextStep !== 1) return false
      [1, 3, 6], // approva dati anagrafici --> if(currentStep === 2 && nextStep !== 1 && nextStep !== 3 && nextStep !== 6) return false
      [6], // invia contratto --> if(currentStep === 3 && nextStep !== 6) return false
      [3, 5, 6], // contratto da approvare --> if(currentStep === 4 && nextStep !== 3 && nextStep !== 5 && nextStep !== 6) return false
      [6], // completa --> if(currentStep === 5 && nextStep !== 6) return false
      [1, 3, 5], // annullata
    ];

    // se sono al primo step posso solo andare allo step successivo
    if (!availableSteps[currentStep].includes(nextStep)) {
      return false;
    }

    // aggiorno ora lo stato
    this.currentBargaining.timeline_status = nextStep;

    // se sono in contratto da approvare posso andare solo in
    switch (nextStep) {
      case 1: // richiedi dati anagrafici
        if (currentStep === 0) {
          await this.requestDocumentMasterData();
        } else {
          await this.openModal(this.noteModal, "document", "md");
        }
        this.currentBargaining.bargaining_document.status = 1;
        break;
      case 3:
        if (currentStep === 2) {
          //Mostro un messaggio di avviso visualizzazione anteprima contratto
          let confirmationText: string = `${await this._utilService.translate("ALERT.CONFIRM_VIEW_PREVIEW_CONTRACT")}`;
          await this._utilService.showSWALDecision({ text: confirmationText, confirmButtonText: "CONFIRM_VIEWED_CONTRACT_BTN" }).then(async (result) => {
            if (result.value) {
              //Vado avanti
              await this.approveDocument("document").then(() => this.requestDocumentContract());
            } else if (result.isDismissed) {
              //Resetto nel caso abbia cliccato annulla
              this.currentBargaining.timeline_status = currentStep;
              return false;
            }
          });
        } else {
          await this.openModal(this.noteModal, "contract", "md");
        }
        this.currentBargaining.bargaining_contract.status = 1;
        break;
      case 5:
        await this.approveDocument("contract");
        break;
      case 6:
        this.openModal(this.noteDisableBargaining, "disable", "sm");
        break;
    }
  }

  async disableBargaining() {
    this._utilService.showLoading();
    this._modalService.dismissAll();
    await this._bargainingService
      .updateBargainingStatus(this.currentBargaining.id, { status: 2, note: this.disableNote })
      .then(async () => {
        await this.loadBargaining();
        this._utilService.hideLoading();
        await this._utilService.showToastrSuccess("SUCCESS_DISABLE_BARGAINING");
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showToastrError("ERROR_DISABLE_BARGAINING");
      });
  }

  async restoreBargaining() {
    // popup
    await this._utilService
      .showSWAL({
        title: "CONFIRM_RESTORE_TITLE",
        icon: "warning",
        confirmButtonText: "CONFIRM_RESTORE_BTN",
        customClass: {
          confirmButton: "btn btn-success",
        },
      })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this._bargainingService
            .updateBargainingStatus(this.currentBargaining.id, { status: 1 })
            // controllare i testi
            .then(async () => {
              await this.loadBargaining();
              this._utilService.hideLoading();
              await this._utilService.showToastrSuccess("SUCCESS_RESTORE_BARGAINING");
            })
            .catch(() => {
              this._utilService.hideLoading();
              this._utilService.showToastrError("ERROR_RESTORE_BARGAINING");
            });
        }
      });
  }

  transformTicketValue(target: any) {
    let value = target.value;
    if (target.id !== "ticket_month_number") {
      if (value.split(",").length > 2) {
        value = value.split(",");
        const decimals: string = value.pop();
        value = value.join(".");
        value += "," + decimals;
      } else if (!value.includes(",")) {
        value += ",00";
      } else {
        value = value.replace(",", ".");
      }
    }

    const totalDaily: number = typeof this._contractManager.data.total_daily == "string" ? Number(this._contractManager.data.total_daily.replace(",", ".")) : this._contractManager.data.total_daily;
    const ticketValue: number = typeof this._contractManager.data.ticket_value == "string" ? Number(this._contractManager.data.ticket_value.replace(",", ".")) : this._contractManager.data.ticket_value;
    const ticketNumber: number =
      typeof this._contractManager.data.ticket_month_number == "string" ? Number(this._contractManager.data.ticket_month_number.replace(",", ".")) : this._contractManager.data.ticket_month_number;

    const ticketTotal = ticketValue * ticketNumber;

    this._contractManager.data.total_daily = totalDaily - ticketTotal / 20;
    if (target.id !== "ticket_month_number") {
      this._contractManager.data.ticket_value = value;
      target.value = value;
    } else {
      this._contractManager.data.ticket_month_number = Number(value);
    }

    this._contractManager.updateData("ticket");
  }

  calculateTicketTotalMonth() {
    const ticketValue = this._utilService.removeDotsFromNumber(this._contractManager.data.ticket_value.toString());
    const ticketMonthNumber = this._utilService.removeDotsFromNumber(this._contractManager.data.ticket_month_number.toString());
    return this._utilService.addDotsToNumber(ticketValue * ticketMonthNumber);
  }

  async resendMasterData() {
    let confirmationText: string = `${await this._utilService.translate("ALERT.CONFIRM_RESEND_REQUEST_MASTERDATA")}`;
    await this._utilService
      .showSWALDecision({
        text: confirmationText,
        confirmButtonText: "CONFIRM_RESEND_MASTERDATA",
      })
      .then(async (result) => {
        if (result.value) {
          //Vado avanti
          await this.requestDocumentMasterData();
        } else if (result.isDismissed) {
          return false;
        }
      });
  }
}
